import React from 'react';
import moment from 'moment';
import './AppointmentCard.css';

const AppointmentCard = ({ appointment }) => {
  const {
    slot_start_time,
    slot_end_time,
    doctor_first_name,
    doctor_last_name,
    status = 'Unknown',
  } = appointment;

  // Convert UTC time to local using moment
  const startMoment = moment.parseZone(slot_start_time).local();
  const endMoment = moment.parseZone(slot_end_time).local();

  const appointmentDate = startMoment.format("YYYY-MM-DD");
  const appointmentTime = `${startMoment.format("HH:mm")} - ${endMoment.format("HH:mm")}`;

  const practitionerName = `${doctor_first_name || ''} ${doctor_last_name || ''}`.trim();

  const statusClass = typeof status === 'string' ? status.toLowerCase() : 'unknown';

  const statusLabelMap = {
    BO: "Booked",
    AP: "Approved",
    CO: "Completed",
    CA: "Cancelled",
    PC: "Payment Completed",
    PW: "Payment Completed Without Doctor Completed",
  };

  const readableStatus = statusLabelMap[status] || status || 'Unknown';

  return (
    <div className="pat-card-container">
      <div className="pat-card-header">
        <div className="pat-card-date-time">
          <h4>{appointmentDate}</h4>
          <p className="pat-card-time">{appointmentTime}</p>
        </div>

        <div className="pat-card-meta-box">
          <p className="pat-card-practitioner">{practitionerName || 'Unknown'}</p>
          <span className={`pat-card-status ${statusClass}`}>{readableStatus}</span>
        </div>

        <div className="pat-card-expand-icon">+</div>
      </div>
    </div>
  );
};

export default AppointmentCard;
